import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-white px-4 py-4" data-id="element-41" data-mp="1hd1oo1j6fe13">
      <div className="mx-auto max-w-3xl" data-id="element-42" data-mp="1hdun8f7zex85">
        <h2 className="mb-2.5 text-center font-display text-[20px] leading-tight sm:text-3xl" data-id="element-43" data-mp="1ceqefpoyz1ic">
          Frequently Asked Questions
        </h2>
        <ul className="space-y-1.5" data-id="element-44" data-mp="2a1qgf9yce706">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <li key={faq.question} data-id="element-45" data-mp="20318a8w900x4" data-mpi={index}>
                <article className="overflow-hidden rounded-lg border border-brand-line bg-brand-paper" data-id="element-46" data-mp="2065k9sfyg0yc">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} className="flex w-full items-center justify-between gap-3 px-3 py-2 text-left transition-colors duration-150 ease-out hover:bg-white" aria-expanded={isOpen} aria-controls={panelId} data-id="element-47" data-mp="1v72h6djjc4t0">
                    <span className="font-cond text-[13px] font-semibold uppercase leading-snug text-brand-carbon sm:text-base" data-id="element-48" data-mp="1ko9o5z9fmdzk">
                      {faq.question}
                    </span>
                    <ChevronDownIcon aria-hidden="true" className={`h-5 w-5 shrink-0 text-brand-carbon transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-49" data-mp="1aorau1o11qgh" />
                  </button>
                  {isOpen && <p id={panelId} className="px-3 pb-2.5 text-[13px] font-medium leading-snug text-brand-muted sm:text-[15px]" data-id="element-50" data-mp="11vxqhptq40vr">
                      {faq.answer}
                    </p>}
                </article>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}